var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ toggleable: _vm.toggleable }},[(_vm.value)?_c('fa-icon',{staticClass:"true",attrs:{"icon":"check-circle"}}):_c('fa-icon',{staticClass:"false",attrs:{"icon":"times-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }